import { Slice as PartitionListSlice } from "./redux/Slice";
export { PartitionList } from "./Partition.logic";

export { PartitionListSlice };
